'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { TransitionStartFunction } from 'react';
import { CLASSNAME_CONTAINED_CONTENT } from '../../../../../../../app/App.constants';
import { cn } from '../../../../../../../lib/utils';
import type { Locale } from '../../../../../../../localization/i18n';
import AdditionalFilters from './components/AdditionalFilters';
import DateFilter from './components/DateFilter';
import TimeFilter from './components/TimeFilter';
interface Props {
  startTransition: TransitionStartFunction;
  locale: Locale;
}
const Filters = t0 => {
  const $ = _c(14);
  const {
    startTransition,
    locale
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router || $[1] !== startTransition) {
    t1 = newRoute => startTransition(() => {
      router.replace(newRoute);
    });
    $[0] = router;
    $[1] = startTransition;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleRouteChange = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn(CLASSNAME_CONTAINED_CONTENT, "flex gap-1 px-1 py-2 sm:gap-2");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleRouteChange || $[5] !== locale) {
    t3 = <DateFilter handleRouteChange={handleRouteChange} locale={locale} />;
    $[4] = handleRouteChange;
    $[5] = locale;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] !== handleRouteChange) {
    t4 = <TimeFilter handleRouteChange={handleRouteChange} />;
    t5 = <AdditionalFilters handleRouteChange={handleRouteChange} />;
    $[7] = handleRouteChange;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default Filters;